import React, { useState } from "react";
import axios from '../util/Api'
import { Link, Redirect } from "react-router-dom";

import * as Icon from 'react-feather';
import { tokensKey } from '../util/Constants'
import 'antd/dist/antd.css';
import { Spin, Modal } from 'antd';
import { ResponsivePieCanvas } from '@nivo/pie'
import "flatpickr/dist/themes/light.css";
import qs from 'qs';
import Flatpickr from "react-flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js"
import {
    ExcelExport,
    ExcelExportColumn,
    ExcelExportColumnGroup,
    ExcelExportFooter,
    ExcelExportGroupFooter,
    ExcelExportGroupHeader
} from "@progress/kendo-react-excel-export";
import { process, aggregateBy } from "@progress/kendo-data-query";
import getStorage from '../context/auth'
import { formatLocalDateOnly } from '../util/Date';


// const aggregatesWeightMerchandise = [
//     { field: "merchandiseWeight", aggregate: "sum" },
//     // { field: "marchandise.announcedWeight", aggregate: "sum" },
//     // { field: "marchandise.difference", aggregate: "sum" }
// ];

const aggregates = [{ field: 'boat', aggregate: 'sum' }];

// const aggregates: AggregateDescriptor[] = [{ field: 'UnitPrice', aggregate: 'sum' }];

const group = [
    { field: "date", aggregates: aggregates },
    { field: "boat", aggregates: aggregates },
];

const measureGroup = [
];

// Details sheet: raw data only (no grouping, no totals)
const detailsGroup = [];



const PortsResponsivePie = ({ data }) => (
    <ResponsivePieCanvas
        data={data}
        margin={{ top: 40, right: 150, bottom: 40, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        colors={{ scheme: 'paired' }}
        borderColor={{ from: 'color', modifiers: [['darker', 0.6]] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextColor="#333333"
        radialLabelsLinkColor={{ from: 'color' }}
        sliceLabelsSkipAngle={10}
        sliceLabelsTextColor="#333333"

    />
)

class PortDetails extends React.Component {

    _exporter;
    export = () => {
        // Prevent double clicks while exporting
        if (this.state?.exporting) return;
        this.setState({ exporting: true }, () => {
            const optionsGridOne = this._exporter?.workbookOptions?.();
            const optionsGridTwo = this._measureExporter.workbookOptions();
            const optionsGridThree = this._detailsExporter.workbookOptions();

            optionsGridOne.sheets[1] = optionsGridTwo.sheets[0];
            optionsGridOne.sheets[2] = optionsGridThree.sheets[0];
            optionsGridOne.sheets[0].title = 'Récap';
            optionsGridOne.sheets[1].title = 'Materiaux';
            optionsGridOne.sheets[2].title = 'Détails';

            try {
                this._exporter?.save?.(optionsGridOne);
            } finally {
                // Saving is async; give it a moment before clearing the loader
                setTimeout(() => this.setState({ exporting: false }), 1200);
            }
        });
    };

    constructor(props) {
        var secondDate = new Date();
        secondDate.setHours(24, 0, 0, 0);

        var date = new Date();
        var firstDate = new Date(date.getFullYear(), date.getMonth(), 1);
        super(props);
        this.getMeasures = this.getMeasures.bind(this);
        this.replaceDotWithComma = this.replaceDotWithComma.bind(this);
        this.state = {
            firstDate,
            secondDate,
            exporting: false
        };
    }

    componentDidMount() {
        this.checkProps();
    }

    componentDidUpdate() {
        this.checkProps();
    }

    checkProps() {
        if (this.props.selectedElement != this.state.selectedElementId) {
            this.setState({
                selectedElementId: this.props.selectedElement
            })
            this.getMeasures()
        }
    }

    getMeasures() {
        const { jwt, user } = JSON.parse(getStorage().getItem(tokensKey));

        if (jwt) {
            const { firstDate, secondDate } = this.state;
            let firstDateQuery = '';
            if (firstDate) {
                firstDateQuery = `&firstDate=${formatLocalDateOnly(firstDate)}`;
                console.log('📅  firstDateQuery →', firstDateQuery);
            }

            let secondDateQuery = '';
            if (secondDate) {
                secondDateQuery = `&secondDate=${formatLocalDateOnly(secondDate)}`;
                console.log('📅  secondDateQuery →', secondDateQuery);
            }

            const portsQuery = this.props.selectedElement.ids
                .map(e => `&portsId[]=${e}`)
                .join('');
            console.log('⚓  portsQuery →', portsQuery);

            const url = `api/mesures/port-stats?id=${user.id}${portsQuery}${firstDateQuery}${secondDateQuery}`;
            console.log('🌐  Fetching measures from →', url);

            this.setState({ isLoading: true }, () => {
                console.log('⏳  isLoading set to true');
            });

            axios.get(url, {
                headers: { Authorization: `Bearer ${jwt}` }
            })
                .then(result => {
                    if (result.status === 200) {
                        console.log('✅  Received data:', result.data);
                        this.setState({
                            portData: result.data,
                            isLoading: false
                        }, () => {
                            console.log('✅  portData updated, isLoading set to false');
                        });
                    } else {
                        console.warn('⚠️  Unexpected status code:', result.status);
                    }
                })
                .catch(e => {
                    console.error('❌  Failed to fetch measures:', e);
                    this.setState({ isLoading: false }, () => {
                        console.log('⏹️  isLoading set to false after error');
                    });
                });
        } else {
            console.error('🔒  No JWT token found, aborting fetch');
        }
    }

    replaceDotWithComma(obj) {
        if (Array.isArray(obj)) {
            return obj.map((item) => this.replaceDotWithComma(item));
        } else if (typeof obj === 'object' && obj !== null) {
            var newObj = {};
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    var newKey = key.replace(/\./g, ',');
                    var newValue = obj[key];
                    if (typeof newValue === 'object' && newValue !== null) {
                        newValue = this.replaceDotWithComma(newValue); // Recursively call the function for nested objects
                    } else if (typeof newValue === 'string') {
                        newValue = newValue.replace(/\./g, ',');
                    }
                    newObj[newKey] = newValue;
                }
            }
            return newObj;
        } else if (typeof obj === 'string') {
            return obj.replace(/\./g, ',');
        } else {
            return obj;
        }
    }

    // Normalize and format a date-like value while preserving the wall-clock time
    // stored in ISO strings used by Bon/Excel date fields.
    // Handles inputs where decimals were globally transformed (e.g. "2025-08-10T00:00:00,000Z").
    formatDateTimeLocal(value) {
        if (!value) return '';
        try {
            let input = value;
            if (typeof input === 'string') {
                // Fix common ISO variant with comma before milliseconds (",000Z") or any stray commas
                // Example: 2025-08-10T00:00:00,000Z -> 2025-08-10T00:00:00.000Z
                input = input
                    .replace(/,(\d{3})(?=Z|[+\-]\d{2}:?\d{2}$)/, '.$1')
                    .replace(',', '.');
            }
            const d = new Date(input);
            if (Number.isNaN(d.getTime())) return typeof value === 'string' ? value : '';
            return d.toLocaleString('fr-FR', {
                timeZone: 'UTC',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
        } catch (_) {
            return typeof value === 'string' ? value : '';
        }
    }

    // Build raw detail rows from merchandise objects per entry/day
    buildDetailsRows(data) {
        const rows = [];
        (data || []).forEach((entry) => {
            Object.keys(entry || {}).forEach((key) => {
                const val = entry[key];
                // Consider only nested merchandise-like objects that carry name + weight
                if (val && typeof val === 'object' && 'name' in val && 'weight' in val) {
                    const announced = typeof val.announcedWeight === 'number' ? val.announcedWeight : 0;
                    const weight = typeof val.weight === 'number' ? val.weight : 0;
                    // Skip rows where both announced and measured weights are zero
                    if (weight === 0 && announced === 0) {
                        return;
                    }
                    const difference = typeof val.difference === 'number' ? val.difference : (typeof weight === 'number' && typeof announced === 'number' ? (weight - announced) : 0);
                    const gapPct = announced
                        ? `${((difference / announced) * 100).toFixed(2).replace('.', ',')}%`
                        : (entry.gapPercentage || '');

                    const volumeRaw = val.volume;
                    const volumeNum = typeof volumeRaw === 'number' ? volumeRaw : Number(volumeRaw);
                    const blankVolDensity = volumeNum === 0 || volumeNum === 1;

                    rows.push({
                        // core identifiers
                        date: entry.date || '',
                        boat: entry.boat || '',
                        originPort: entry.originPort || '',
                        arrivalPort: entry.arrivalPort || '',
                        uniqueNumber: entry.uniqueNumber || '',

                        // merchandise-level values
                        merchandise: val.name,
                        merchandiseNumber: val.number || '',
                        merchandiseAnnouncedWeight: announced || 0,
                        merchandiseWeight: weight || 0,
                        merchandiseDifference: difference || 0,
                        gapPercentage: gapPct,
                        volume: blankVolDensity ? '' : volumeRaw,
                        density: blankVolDensity ? '' : val.density,

                        // entry-level environment
                        humidity: entry.humidity,
                        arrivalDate: this.formatDateTimeLocal(entry.arrivalDate),
                        loadedMeasureDate: this.formatDateTimeLocal(entry.loadedMeasureDate),
                        emptyMeasureDate: this.formatDateTimeLocal(entry.emptyMeasureDate),
                    });
                }
            });
        });
        return rows;
    }

    flattenData(data) {
        const flattened = [];

        data.forEach(entry => {
            Object.keys(entry).forEach(key => {
                if (
                    key !== 'net' && key !== 'announced' && key !== 'difference' &&
                    key !== 'boat' && key !== 'date' && key !== 'status' &&
                    key !== 'originPort' && key !== 'arrivalPort' && key !== 'measure' &&
                    key !== 'emptyMeasure' && key !== 'humidity' && key !== 'uniqueNumber' &&
                    key !== 'arrivalDate' && key !== 'loadedMeasureDate' && key !== 'emptyMeasureDate' &&
                    key !== 'gapPercentage'
                ) {
                    const merchandise = entry[key];
                    flattened.push({
                        // top-level
                        uniqueNumber: entry.uniqueNumber,
                        net: entry.net,
                        announced: entry.announced,
                        boat: entry.boat,
                        date: entry.date,
                        humidity: entry.humidity,
                        status: entry.status,
                        originPort: entry.originPort,
                        arrivalPort: entry.arrivalPort,
                        measure: entry.measure,
                        emptyMeasure: entry.emptyMeasure,
                        difference: entry.difference,
                        gapPercentage: entry.gapPercentage,
                        arrivalDate: entry.arrivalDate,
                        loadedMeasureDate: entry.loadedMeasureDate,
                        emptyMeasureDate: entry.emptyMeasureDate,
                        // merchandise-level
                        merchandise: merchandise.name,
                        merchandiseWeight: merchandise.weight,
                        merchandiseAnnouncedWeight: merchandise.announcedWeight,
                        merchandiseDifference: merchandise.difference,
                        merchandiseNumber: merchandise.number,
                        volume: merchandise.volume,
                        density: merchandise.density
                    });
                }
            });
        });
        return flattened;
    }

    transformMeasureData(data) {
        const result = [];

        const merchandiseMap = data.reduce((acc, item) => {
            const { merchandise, merchandiseWeight, merchandiseAnnouncedWeight, merchandiseDifference } = item;

            if (!acc[merchandise]) {
                acc[merchandise] = {
                    merchandiseName: merchandise,
                    merchandiseTotalWeight: 0,
                    merchandiseTotalAnnouncedWeight: 0,
                    merchandiseTotalDifference: 0
                };
            }

            acc[merchandise].merchandiseTotalWeight += merchandiseWeight || 0;
            acc[merchandise].merchandiseTotalAnnouncedWeight += merchandiseAnnouncedWeight || 0;
            acc[merchandise].merchandiseTotalDifference += merchandiseDifference || 0;

            return acc;
        }, {});

        for (const key in merchandiseMap) {
            result.push(merchandiseMap[key]);
        }

        return result;
    }



    render() {

        const { firstDate, secondDate, portData, isLoading } = this.state;
        const { selectedElement } = this.props;

        var { originWeights, arrivalWeights, dataMeasure, merchandiseList } = portData ?? { originWeights: null, arrivalWeights: null, dataMeasure: null, merchandiseList: [] }
        dataMeasure = this.replaceDotWithComma(dataMeasure);
        merchandiseList = this.replaceDotWithComma(merchandiseList);
        const dataFlattened = dataMeasure ? this.flattenData(dataMeasure) : null;
        const data = dataFlattened
            ? process(dataFlattened, {
                group: group
            }).data
            : null;
        const meeasureRecap = dataFlattened ? this.transformMeasureData(dataFlattened) : null;
        const measureData = meeasureRecap
            ? process(meeasureRecap, {
                group: measureGroup
            }).data
            : null;
        // Details sheet: raw rows per day/boat/merchandise using nested merchandise weights only
        const detailsData = dataMeasure ? this.buildDetailsRows(dataMeasure) : null;


        console.log("data measure", dataFlattened);
        console.log("data", data);

        return <div className="row text-left">

            <div className="col-lg-12 col-12 rounded shadow p-4">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4 font-weight-bold">{selectedElement.name}</h4>
                        </div>
                    </div>{/*end col*/}
                </div>
                {
                    portData && <div className="row justify-content-center">
                        <a>
                            <div class="alert alert-light alert-pills" role="alert" onClick={this.state.exporting ? undefined : this.export}>
                                <span class="badge badge-primary badge-pill mr-1">{this.state.exporting ? 'Export…' : 'Export'}</span>
                                <span class="content">
                                    {this.state.exporting ? <Spin size="small" /> : <>Excel<Icon.ChevronRight className="fea icon-sm" /></>}
                                </span>
                            </div>
                        </a>
                    </div>
                }
                <div className="accordion" id="accordionExample">

                    <div className="card border-0 rounded mb-2">
                        <a data-toggle="collapse" href="#collapsethree" className="faq position-relative collapsed" aria-expanded="false" aria-controls="collapsethree">
                            <div className="card-header border-0 bg-light p-3 pr-5" id="headingthree">
                                <h6 className="title mb-0"> Filtrer par date </h6>
                            </div>
                        </a>
                        <div id="collapsethree">
                            <div className="col mt-8 pt-2">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="form-group">
                                            <label> Date début: </label>
                                            <Flatpickr
                                                value={firstDate}
                                                onChange={firstDate => {
                                                    this.setState({ firstDate: firstDate[0] }, () => {
                                                        this.getMeasures();
                                                    });

                                                }}
                                                key={this.state.language}
                                                options={{ locale: French, dateFormat: "d/m/Y" }}
                                                render={
                                                    ({ defaultValue, value, ...props }, ref) => {
                                                        return <input {...props} defaultValue={defaultValue} ref={ref} name="date" type="text" className="flatpickr flatpickr-input form-control" id="checkin-date" />
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="form-group">
                                            <label> Date fin : </label>
                                            <Flatpickr
                                                value={secondDate}
                                                onChange={secondDate => {
                                                    this.setState({ secondDate: secondDate[0] }, () => {
                                                        this.getMeasures();
                                                    });
                                                }}
                                                key={this.state.language}
                                                options={{ locale: French, dateFormat: "d/m/Y" }}
                                                render={
                                                    ({ defaultValue, value, ...props }, ref) => {
                                                        return <input {...props} defaultValue={defaultValue} ref={ref} name="date" type="text" className="flatpickr flatpickr-input form-control" id="checkin-date" />
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    (!portData || isLoading) &&
                    <div className="row justify-content-center">
                        <Spin />
                    </div>
                }
                {
                    portData && (
                        <div className="component-wrapper rounded shadow">
                            <div className="p-4 border-bottom">
                                <h5 className="font-weight-bold">Statistiques des marchandises</h5>
                            </div>
                            <div className="row justify-content-right">
                                {/* Origin Weights (Chargement) */}
                                {Object.keys(originWeights || {}).length === 0 ? (
                                    <div className="col-lg-6 col-md-12 p-4">
                                        <div className="card features px-md-3 border-0 text-center">
                                            <div className="icons rounded h1 text-center text-primary px-3">
                                                <i className={`uil uil-dizzy-meh`} />
                                            </div>
                                            <div className="card-body p-0 content">
                                                <h5 className="mt-4">
                                                    <a href="javascript:void(0)" className="title text-dark">
                                                        Aucun chargement
                                                    </a>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-lg-6 col-md-12 text-center">
                                        <div style={{ height: 320, width: 450 }}>
                                            <PortsResponsivePie
                                                data={Object.entries(originWeights || {}).map(([name, data]) => ({
                                                    id: name,
                                                    value: data.weight,
                                                }))}
                                            />
                                        </div>
                                        <h6 className="font-weight-bold justify-content-right">
                                            Total de :{" "}
                                            {Object.values(originWeights || {}).reduce(
                                                (sum, item) => sum + (item.weight || 0),
                                                0
                                            ).toFixed(2)}
                                        </h6>
                                        <h6 className="font-weight-bold justify-content-right">
                                            <span className="badge badge-pill badge-dark mr-2 mt-2">
                                                Chargement
                                            </span>
                                        </h6>
                                    </div>
                                )}

                                {/* Arrival Weights (Déchargement) */}
                                {Object.keys(arrivalWeights || {}).length === 0 ? (
                                    <div className="col-lg-6 col-md-12 p-4">
                                        <div className="card features px-md-3 border-0 text-center">
                                            <div className="icons rounded h1 text-center text-primary px-3">
                                                <i className={`uil uil-dizzy-meh`} />
                                            </div>
                                            <div className="card-body p-0 content">
                                                <h5 className="mt-4">
                                                    <a href="javascript:void(0)" className="title text-dark">
                                                        Aucun déchargement
                                                    </a>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-lg-6 col-md-12 text-center">
                                        <div style={{ height: 320, width: 450 }}>
                                            <PortsResponsivePie
                                                data={Object.entries(arrivalWeights || {}).map(([name, data]) => ({
                                                    id: name,
                                                    value: data.weight,
                                                }))}
                                            />
                                        </div>
                                        <h6 className="font-weight-bold justify-content-right">
                                            Total de :{" "}
                                            {Object.values(arrivalWeights || {}).reduce(
                                                (sum, item) => sum + (item.weight || 0),
                                                0
                                            ).toFixed(2)}
                                        </h6>
                                        <h6 className="font-weight-bold justify-content-right">
                                            <span className="badge badge-pill badge-dark mr-2 mt-2">
                                                Déchargement
                                            </span>
                                        </h6>
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                }

            </div>
            <ExcelExport
                data={data}
                group={group}
                fileName="Jaugeurs_Stats.xlsx"
                ref={exporter => {
                    this._exporter = exporter;
                }}
                headerCellOptions={{
                    background: "#ff0000",
                    textAlign: "center"
                }}
                footerCellOptions={{
                    background: "#00ff7f",
                    textAlign: "center"
                }}

            >
                <ExcelExportColumn
                    field="boat"
                    title="Bateau"
                    hidden={true}
                    groupHeaderCellOptions={{
                        textAlign: "left",
                        fontSize: 15,
                        fontWeight: "bold",
                        fontStyle: "italic"
                    }}
                />
                <ExcelExportColumn
                    field="date"
                    title="Date"
                    hidden={true}
                    groupHeader={class PortHeader extends ExcelExportGroupHeader {
                        render() {
                            return `${this.props.value}`;
                        }
                    }}
                    groupHeaderCellOptions={{
                        background: "#74b1ed",
                        textAlign: "center",
                        fontSize: 18,
                        fontWeight: "bold"
                    }}
                />
                <ExcelExportColumn
                    field="originPort"
                    title="Port de chargement"
                />
                <ExcelExportColumn
                    field="arrivalPort"
                    title="Port de déchargement"
                />
                <ExcelExportColumn field="uniqueNumber" title="Numéro bon de jaugeage" />
                <ExcelExportColumn field="merchandiseNumber" title="Numéro envoi" />
                <ExcelExportColumn
                    field="merchandise"
                    title="Materiaux"
                />
                <ExcelExportColumn
                    field="merchandiseAnnouncedWeight"
                    title="Tonnage annoncé"
                    footer={() => `Tonnage annoncé cumulé: ${dataFlattened.reduce((totalSum, item) => totalSum + (item.merchandiseAnnouncedWeight || 0), 0).toFixed(2)}`}
                    footerCellOptions={{
                        background: "#008015",
                        textAlign: "center",
                        fontSize: 18,
                        fontWeight: "bold",
                        color: "#ffffff"
                    }}
                    groupFooter={(props) => {
                        // console.log("propoussa", props);
                        const subGroupWeigt = props.group.items[0].net;
                        if (subGroupWeigt) {
                            const subGroupSum = props.group.items.reduce((sum, subItem) => sum + (subItem.merchandiseAnnouncedWeight || 0), 0).toFixed(2);
                            return `Total pour bateau : ${subGroupSum}`;
                        }

                        const groupWeight = props.aggregates.group.items?.reduce((totalSum, item) => {
                            const itemSum = item.items?.reduce((sum, subItem) => sum + (subItem.merchandiseAnnouncedWeight || 0), 0) ?? 0;
                            return totalSum + itemSum;
                        }, 0)?.toFixed(2) || '0.00';
                        return `Total pour journée : ${groupWeight}`;
                    }}
                    groupFooterCellOptions={{
                        background: "#ebf5ff",
                        textAlign: "right",
                        fontSize: 17,
                        fontWeight: "bold"
                    }}
                />
                <ExcelExportColumn
                    field="merchandiseWeight"
                    title="Tonnage jaugé"
                    footer={() => `Tonnage jaugé cumulé : ${dataFlattened.reduce((totalSum, item) => totalSum + (item.merchandiseWeight || 0), 0).toFixed(2)}`}
                    footerCellOptions={{
                        background: "#008015",
                        textAlign: "center",
                        fontSize: 18,
                        fontWeight: "bold",
                        color: "#ffffff"
                    }}
                    groupFooter={(props) => {
                        // console.log("propoussa", props);
                        const subGroupWeigt = props.group.items[0].net;
                        if (subGroupWeigt) {
                            const subGroupSum = props.group.items.reduce((sum, subItem) => sum + (subItem.merchandiseWeight || 0), 0).toFixed(2);
                            return `Total pour bateau : ${subGroupSum}`;
                        }

                        const groupWeight = props.aggregates.group.items?.reduce((totalSum, item) => {
                            const itemSum = item.items?.reduce((sum, subItem) => sum + (subItem.merchandiseWeight || 0), 0) ?? 0;
                            return totalSum + itemSum;
                        }, 0)?.toFixed(2) || '0.00';
                        return `Total pour journée : ${groupWeight}`;
                    }}
                    groupFooterCellOptions={{
                        background: "#ebf5ff",
                        textAlign: "right",
                        fontSize: 17,
                        fontWeight: "bold"
                    }}
                />
                <ExcelExportColumn
                    field="merchandiseDifference"
                    title="Différence G-H"
                    footer={() => `Différence cumulée : ${dataFlattened.reduce((totalSum, item) => totalSum + (item.merchandiseDifference || 0), 0).toFixed(2)}`}
                    footerCellOptions={{
                        background: "#008015",
                        textAlign: "center",
                        fontSize: 18,
                        fontWeight: "bold",
                        color: "#ffffff"
                    }}
                    groupFooter={(props) => {
                        // console.log("propoussa", props);
                        const subGroupWeigt = props.group.items[0].net;
                        if (subGroupWeigt) {
                            const subGroupSum = props.group.items.reduce((sum, subItem) => sum + (subItem.merchandiseDifference || 0), 0).toFixed(2);
                            return `Total pour bateau : ${subGroupSum}`;
                        }

                        const groupWeight = props.aggregates.group.items?.reduce((totalSum, item) => {
                            const itemSum = item.items?.reduce((sum, subItem) => sum + (subItem.merchandiseDifference || 0), 0) ?? 0;
                            return totalSum + itemSum;
                        }, 0)?.toFixed(2) || '0.00';
                        return `Total pour journée : ${groupWeight}`;
                    }}
                    groupFooterCellOptions={{
                        background: "#ebf5ff",
                        textAlign: "right",
                        fontSize: 17,
                        fontWeight: "bold"
                    }}
                />
                <ExcelExportColumn
                    field="humidity"
                    title="Humidité"
                    footer={() => {
                        const total = dataFlattened.reduce((acc, item) => {
                            if (item.humidity > 0) {
                                acc.sum += item.humidity;
                                acc.count++;
                            }
                            return acc;
                        }, { sum: 0, count: 0 });

                        const average = total.count > 0 ? total.sum / total.count : 0;
                        return average > 0 ? `Moyenne Humidité : ${average.toFixed(2)}` : '';
                    }}
                    footerCellOptions={{
                        background: "#008015",
                        textAlign: "center",
                        fontSize: 18,
                        fontWeight: "bold",
                        color: "#ffffff"
                    }}
                    groupFooter={(props) => {
                        const subGroupWeight = props.group.items[0]?.net || 0;

                        if (subGroupWeight) {
                            // Calculate the average humidity for the subgroup
                            const subGroupSum = (props.group?.items ?? []).reduce((sum, subItem) => sum + (subItem?.humidity || 0), 0).toFixed(2);
                            const subGroupCount = (props.group?.items ?? []).filter(subItem => subItem?.humidity !== undefined && subItem?.humidity !== 0).length; // Count only items with non-zero humidity
                            const subGroupAverage = subGroupCount > 0 ? subGroupSum / subGroupCount : 0; // Avoid division by zero

                            // Only show the result if the average is greater than zero
                            if (subGroupAverage > 0) {
                                return `Moyenne Humidité (Bateau): ${subGroupAverage.toFixed(2)}`;
                            }

                            return null;
                        }

                        // Calculate the average humidity for the entire group
                        const groupSum = (props.aggregates?.group?.items ?? []).reduce((totalSum, item) => {
                            const items = item?.items ?? [];
                            const itemSum = items.reduce((sum, subItem) => sum + (subItem?.humidity || 0), 0);
                            const itemCount = items.filter(subItem => subItem?.humidity !== undefined && subItem?.humidity !== 0).length; // Count only items with non-zero humidity
                            return {
                                sum: totalSum.sum + itemSum,
                                count: totalSum.count + itemCount
                            };
                        }, { sum: 0, count: 0 }); // Initialize with sum and count

                        const groupAverage = groupSum.count > 0 ? groupSum.sum / groupSum.count : 0; // Avoid division by zero

                        if (groupAverage > 0) {
                            return `Moyenne Humidité (Journée): ${groupAverage.toFixed(2)}`;
                        }

                        // Return nothing if both averages are zero
                        return null;
                    }}
                    groupFooterCellOptions={{
                        background: "#ebf5ff",
                        textAlign: "right",
                        fontSize: 17,
                        fontWeight: "bold"
                    }}
                />
            </ExcelExport>
            <ExcelExport
                data={measureData}
                group={measureGroup}
                fileName="Jaugeurs_Stats.xlsx"
                ref={exporter => {
                    this._measureExporter = exporter;
                }}
                headerCellOptions={{
                    background: "#ff0000",
                    textAlign: "center"
                }}
                footerCellOptions={{
                    background: "#00ff7f",
                    textAlign: "center"
                }}
            />

            <ExcelExport
                data={detailsData}
                fileName="Jaugeurs_Stats.xlsx"
                ref={exporter => {
                    this._detailsExporter = exporter;
                }}
                headerCellOptions={{
                    background: "#4CAF50",
                    textAlign: "center"
                }}
            >
                <ExcelExportColumn field="boat" title="Nom du bateau" />
                <ExcelExportColumn field="date" title="Date" />
                <ExcelExportColumn field="originPort" title="Port de chargement" />
                <ExcelExportColumn field="arrivalPort" title="Port de déchargement" />
                <ExcelExportColumn field="uniqueNumber" title="Numéro bon de jaugeage" />
                <ExcelExportColumn field="merchandiseNumber" title="Numéro de commande" />
                <ExcelExportColumn field="merchandise" title="Marchandise" />
                <ExcelExportColumn field="merchandiseAnnouncedWeight" title="Tonnage annoncé" />
                <ExcelExportColumn field="merchandiseWeight" title="Tonnage jaugé" />
                <ExcelExportColumn field="merchandiseDifference" title="Différence G-H" />
                <ExcelExportColumn field="gapPercentage" title="% de l'écart" />
                <ExcelExportColumn field="volume" title="Volume de la cale" />
                <ExcelExportColumn field="density" title="Densité" />
                <ExcelExportColumn field="humidity" title="Humidité" />
                <ExcelExportColumn field="arrivalDate" title="Date heure d'arrivée du bateau" />
                <ExcelExportColumn field="loadedMeasureDate" title="Date heure de jaugeage à charge" />
                <ExcelExportColumn field="emptyMeasureDate" title="Date heure de jaugeage à vide" />
            </ExcelExport>


        </div>
    }
}


class PortsList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sectionNumber: 0,
            searchContent: "",
            isModalOpen: false,
            selectedItems: [],
        };
    }

    handleClose = () => {
        this.setState({
            isModalOpen: false
        })
    };

    handleOk = () => {
        this.setState({
            isModalOpen: false
        })
    };

    selectAll = () => {
        this.setState({
            selectedItems: this.props.ports.filter(e => e.port).map(e => e.port.id)
        })
    }

    showSelected = () => {
        const selectedItems = this.state.selectedItems;
        this.setState({
            isModalOpen: true,
            selectedElement: {
                name: "Ensemble de ports selectionnés",
                ids: selectedItems
            }
        })
    }


    render() {

        const { ports } = this.props;
        const { isModalOpen, selectedElement, selectedItems } = this.state;
        const selectedStyle = {
            "border-style": "solid",
            "border-width": "5px",
            "border-radius": "10px",
            "border-color": "#2f55d4"

        };
        const unselectedStyle = {
            "border-style": "",
            "border-width": "1px",
            "border-radius": "3px",
            "border-color": "light-grey"

        };

        return <div>
            <div>
                {
                    selectedItems
                    && selectedItems.length != 0
                    && <div className="col-lg-6">
                        <div className="row text-right">
                            <Link className="badge badge-primary" onClick={this.showSelected}> Voir stats des ports sélectionnés </Link>
                            <Link className="badge badge-outline-primary" onClick={this.selectAll} style={{ marginLeft: "10px" }}> Sélectionner tout </Link>
                        </div>
                    </div>
                }
            </div>
            <div className="row">
                {
                    ports && ports.map(port => <div className="col-lg-6 col-md-6 col-12 mt-4 pt-2" onClick={
                        e => {
                            if (port.port) {
                                let items = selectedItems
                                let portDetails = port.port
                                if (!items.includes(portDetails.id)) {
                                    items.push(portDetails.id)
                                } else {
                                    items = items.filter(id => id != portDetails.id)
                                }
                                this.setState({
                                    selectedItems: items
                                })
                            }
                        }
                    }>
                        <div className="card blog rounded shadow overflow-hidden" style={port.port && selectedItems.includes(port.port.id) ? selectedStyle : unselectedStyle}>
                            <div className="overflow-hidden rounded shadow border-0">
                                <img src={port.photo ? (port.photo.formats && port.photo.formats.medium ? port.photo.formats.medium.url : port.photo.url) : ""} className="img-fluid" alt="" style={{ height: '200px', 'width': '100%' }} />
                                <div className="card-body">
                                    <ul className="list-unstyled d-flex justify-content-between mb-0">
                                        <li><a href="javascript:void(0)" className="title h6 text-dark">{port.port && port.port.name}</a></li>
                                    </ul>
                                    <a href="javascript:void(0)" onClick={
                                        e => {
                                            this.setState({
                                                isModalOpen: true,
                                                selectedElement: {
                                                    name: port.port.name,
                                                    ids: [port.port.id]
                                                }
                                            })
                                        }
                                    }
                                        className="text-primary">Afficher détails <Icon.ChevronRight className="fea icon-sm" /></a>
                                </div>
                            </div>
                        </div>
                    </div>)
                }
                {
                    ports && ports.length == 0 && <div className="col-lg-12 col-12 p-4">
                        <div className="card features border-0 text-center">
                            <div className="icons rounded h1 text-center text-primary px-3">
                                <i className={`uil ${"uil-apps"}`} />
                            </div>
                            <div className="card-body p-0 content">
                                <h5 className="mt-4"><a href="javascript:void(0)" className="title text-dark">Pas de ports</a></h5>
                            </div>
                        </div>
                    </div>
                }


                {
                    selectedElement &&
                    <Modal
                        visible={isModalOpen}
                        onOk={this.handleOk}
                        onCancel={this.handleClose}
                        width={1000}
                        height={800}
                        footer={[]}>
                        <PortDetails selectedElement={selectedElement} />
                    </Modal>}
            </div>
        </div>
    }
}

export default PortsList;
